import { memo, ReactNode } from 'react';
import { resolveAssetUrl } from '../../../utils/resolveAssetUrl';
import { ICheckoutItem } from '../../../interfaces/ICheckout';

type ProductInfoProps = {
  firstItem: ICheckoutItem;
  children: ReactNode;
};

const ProductInfo = memo(({ firstItem, children }: ProductInfoProps) => {
  return (
    <div className="w-full flex items-center gap-4 mb-2">
      {firstItem?.image && (
        <img
          className="rounded-lg w-full max-w-24 sm:max-w-32 aspect-square object-cover"
          src={resolveAssetUrl(firstItem?.image)}
        />
      )}
      <div className="flex flex-col gap-1">
        <h1 className="text-base sm:text-lg leading-tight m-0 font-medium text-black">
          {firstItem?.description}
        </h1>
        {children}
      </div>
    </div>
  );
});

ProductInfo.displayName = 'ProductInfo';

export default ProductInfo;
